import React from "react"
import { get } from "lodash"
import styled, { css } from "styled-components"
import SectionLayout from "../../Layouts/SectionLayout"
import Title from "../../components/Text/Title"
import C from "../../components/Color"

const ContentBlock = styled.div`
  position: relative;
  z-index: 13;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  justify-content: ${props => get(flexAlignment, props.align, "center")};
  align-items: ${props => get(flexAlignment, props.align, "center")};
  flex-direction: column;
`

const flexAlignment = {
  left: "flex-start",
  center: "center",
  right: "flex-end",
}

const TrustpilotWidget = styled.div`
  width: 100%;
  display: flex;
  justify-content: ${props => get(flexAlignment, props.align, "center")};

  ${props =>
    get(flexAlignment, props.align, "center") !== "center"
      ? css`
          > div {
            min-width: 300px;
          }
        `
      : css`
          > div {
            width: 100%;
            // min-width: 300px;
          }
        `};
`

export default props => {
  return (
    <SectionLayout>
      <ContentBlock align={props.align}>
        <Title margin={{ bottom: "small" }} serif>
          <C type={"primary"}>{props.headline}</C>
        </Title>
        <Title margin={{ bottom: "large" }} size="medium" serif>
          <C type={"primary"}>{props.subHeadline}</C>
        </Title>
        <TrustpilotWidget
          align={props.align}
          dangerouslySetInnerHTML={{ __html: props.widgetCode }}
        />
      </ContentBlock>
    </SectionLayout>
  )
}
